import { IconButton, Menu, MenuItem } from '@material-ui/core'
import MoreIcon from '@material-ui/icons/MoreVert'
import { useState } from 'react'

import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import useStyles from '../CancelPoliciesList/styles/PoliciesTable.styles'

interface AddOnPolicyRowMenuProps {
  id: string
  providerCode: string
  canEdit: boolean
  canDelete: boolean
  openTable: () => void
  openDelete: () => void
}

export const AddOnPolicyRowMenu: React.FC<AddOnPolicyRowMenuProps> = ({
  id,
  providerCode,
  canEdit,
  canDelete,
  openTable,
  openDelete
}) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const runAndClose = (action: () => void) => () => {
    setAnchorEl(null)
    action()
  }

  return (
    <>
      <IconButton
        aria-label={getTranslate('Actions')}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        className={classes.moreIcon}>
        <MoreIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}>
        {canEdit && (
          <MenuItem
            component={LocalizedLink}
            to={`/policies/add-on-policies/${providerCode}/${id}/edit`}>
            {getTranslate('Edit Policy')}
          </MenuItem>
        )}
        <MenuItem button onClick={runAndClose(openTable)}>
          {getTranslate('View Policy Table')}
        </MenuItem>
        {canDelete && (
          <MenuItem button onClick={runAndClose(openDelete)}>
            {getTranslate('Delete')}
          </MenuItem>
        )}
      </Menu>
    </>
  )
}
